import subProgram from '@/api/sub-program'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  main_programs: [],
  cardTemplates: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_MAIN_PROGRAMS(state, data) {
    state.main_programs = data
  },
  SET_CARD_TEMPLATES(state, data) {
    state.cardTemplates = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return subProgram.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return subProgram.store(data)
  },

  async find(context, id) {
    return await subProgram.find(id)
  },

  update(context, data) {
    return subProgram.update(data)
  },

  delete(context, data) {
    return subProgram.destroy(data)
  },

  async dataBeforeCreate(context) {
    if (!context.state.main_programs.length > 0) {
      let response = await subProgram.mainProgram()
      context.commit('SET_MAIN_PROGRAMS', response)
    }
    if (!context.state.cardTemplates.length > 0) {
      let response = await subProgram.cardTemplate()
      context.commit('SET_CARD_TEMPLATES', response)
    }
  },

  getScoringCycle(context, data) {
    return subProgram.getScoringCycle(data)
  }
}
